import { InsuranceRcaControls } from '../InsuranceRcaControls'
import { useRcaInsuranceValues } from './RcaInsuranceContext'
import { RcaFormValues } from './types'
import {
  formProps,
  normalizeOrderData,
  removeRcaValuesFromStorage
} from './utils'

type Props = {
  steps: number
  onReadyToSaveData?: () => void
}

export const RcaInsuranceControls = ({ steps, onReadyToSaveData }: Props) => {
  const { handleCalculate, isCalculatingLoading } = useRcaInsuranceValues()
  const { orderKey } = formProps()

  return (
    <InsuranceRcaControls
      steps={steps}
      onReadyToSaveData={onReadyToSaveData}
      removeFromStorage={removeRcaValuesFromStorage}
      handleCalculate={handleCalculate}
      isCalculatingLoading={isCalculatingLoading}
      errorUnwrapKeys={['rca']}
      normalizeOrderData={(values) => ({
        id: values[orderKey.name] as number,
        requestBody: { rca: normalizeOrderData(values as RcaFormValues) }
      })}
    />
  )
}
